import { graphql } from '@data-access/graphql'
import type { ResultOf, VariablesOf } from '@graphql-typed-document-node/core'

const AccommodationSearchItemFragmentDoc = graphql(`
  fragment AccommodationSearchItem on AccommodationSearchItem {
    __typename
    id
    name
    slug
    city
    numberOfReviews
    reviewScore
    pricing {
      price
      currency
      originalPrice
      discountPercentage
      tags
      pricePerNight
    }
    stars
    images {
      url
    }
    isRecommended
    lat
    lng
  }
`)

export const AccommodationSearchDocument = graphql(`
  query accommodationSearch(
    $filter: AccommodationSearchInput!
    $locale: String!
    $pagination: PaginationInput!
    $sorting: ProductSorting
    $cacheBehavior: CacheBehavior
  ) {
    accommodationSearch(
      filter: $filter
      locale: $locale
      pagination: $pagination
      sorting: $sorting
      cacheBehavior: $cacheBehavior
    ) {
      count
      data {
        ...AccommodationSearchItem
      }
    }
  }
`)

const _AccommodationRoomFacilityFragmentDoc = graphql(`
  fragment AccommodationRoomFacility on AccommodationRoomFacility {
    id
    name
  }
`)

const _AccommodationRoomSegmentFragmentDoc = graphql(`
  fragment AccommodationRoomSegment on AccommodationRoomSegment {
    roomType
    externalId
    beds {
      count
      bedType
    }
  }
`)

const _AccommodationRoomRateFragmentDoc = graphql(`
  fragment AccommodationRoomRate on AccommodationRate {
    id
    details
    cancelationDeadline {
      local
      timezone
      utc
    }
    mealPlan
    pricing {
      price
      currency
      originalPrice
      discountPercentage
      tags
      pricePerNight
    }
    title
    productId
    available
    occupancy {
      adults
      children
      total
    }
  }
`)

const AccommodationAvailableRoomFragmentDoc = graphql(`
  fragment AccommodationAvailableRoom on AccommodationRoom {
    id
    title
    bathrooms
    bedrooms
    livingRooms
    descriptionHtml
    facilityTypes {
      id
      name
      facilities {
        ...AccommodationRoomFacility
      }
    }
    segments {
      ...AccommodationRoomSegment
    }
    rates {
      ...AccommodationRoomRate
    }
    images {
      url
    }
    size
  }
`)

const AlternativeDateFragmentDoc = graphql(`
  fragment AlternativeDate on AccommodationAlternativeDateObject {
    checkin
    checkout
    price
    currency
    lengthOfStay
  }
`)

export const AccommodationAvailableRoomsDocument = graphql(`
  query accommodationAvailableRooms($input: AccommodationAvailableRoomsInput!) {
    availableRooms(input: $input) {
      rooms {
        ...AccommodationAvailableRoom
      }
      alternativeDates {
        ...AlternativeDate
      }
    }
  }
`)

export type AccommodationSearchQuery = ResultOf<typeof AccommodationSearchDocument>
export type AccommodationSearchQueryVariables = VariablesOf<typeof AccommodationSearchDocument>
export type AccommodationAvailableRoomsQuery = ResultOf<typeof AccommodationAvailableRoomsDocument>
export type AccommodationAvailableRoomsQueryVariables = VariablesOf<
  typeof AccommodationAvailableRoomsDocument
>

export type AccommodationSearchItemFragment = ResultOf<typeof AccommodationSearchItemFragmentDoc>
export type AccommodationAvailableRoomFragment = ResultOf<
  typeof AccommodationAvailableRoomFragmentDoc
>
export type AlternativeDateFragment = ResultOf<typeof AlternativeDateFragmentDoc>
